import { CreativeAgency } from "models/creativeAgencies"
import { http } from "./http"

export const fetchCreativeAgencies = async (_key: string) => {
  const { data } = await http
    .get(`creative-agencies`)
    .json<{ data: CreativeAgency[] }>()
  return data
}

export const fetchCreativeAgency = async (_key: string, id: string) => {
  const { data } = await http
    .get(`creative-agencies/${id}`)
    .json<{ data: CreativeAgency }>()
  return data
}

export const createCreativeAgency = async (pld: Partial<CreativeAgency>) => {
  const { ...body } = pld
  await http.post(`creative-agencies`, { json: body })
}

export const patchCreativeAgency = async (
  pld: Partial<CreativeAgency>,
): Promise<CreativeAgency> => {
  const { id, ...data } = pld
  return (await http.patch(`creative-agencies/${id}`, { json: data })) as any
}

export const deleteCreativeAgency = async (pld: {
  creativeAgencyId: string
}) => {
  await http.delete(`creative-agencies/${pld.creativeAgencyId}`)
}

export const activateCreativeAgency = async (pld: {
  creativeAgencyId: string
}) => {
  return await http.post(`creative-agencies/${pld.creativeAgencyId}/activate`)
}

export const deactivateCreativeAgency = async (pld: {
  creativeAgencyId: string
}) => {
  return await http.post(`creative-agencies/${pld.creativeAgencyId}/deactivate`)
}
